import React from 'react'
import { Row, Col, Icon, IconButton, ButtonGroup, Message } from 'rsuite'
import moment from 'moment'
import { getValueFromOptions, maskIdCard } from '../../utils/dataUtil'

export default function PersonalBasicInfoView({ data, handleFile, fileErr, setFileErr }) {
  const honorificValue = getValueFromOptions(data?.honorific?.options, data?.honorific?.value)

  let nationalityValue
  if (data?.nationality?.value === 2) {
    nationalityValue = data.nationality.inputOther?.value
  } else {
    nationalityValue = getValueFromOptions(data?.nationality?.options, data?.nationality?.value)
  }

  const personTypeValue = getValueFromOptions(data?.personType?.options, data?.personType?.value)

  const firstName = data?.firstName?.value || ''
  const lastName = data?.lastName?.value || ''
  let fullName = '-ไม่ระบุ-'
  if (honorificValue || firstName || lastName) {
    fullName = `${honorificValue}${firstName} ${lastName}`
  }

  const ColData = ({ data, value, isIdCard, xs = 24, sm = 12, md = 8, lg = 8 }) => {
    return (
      <Col xs={xs} sm={sm} md={md} lg={lg}>
        <span>
          &#9679; {data.label} :{' '}
          <b>
            {isIdCard
              ? maskIdCard(value || data?.value || '-ไม่ระบุ-')
              : value || data?.value || '-ไม่ระบุ-'}
          </b>
        </span>
      </Col>
    )
  }

  return (
    <>
      {data.thaiDVerified && (
        <Message
          showIcon={false}
          type={'success'}
          description={
            <>
              <Icon size="3x" style={{ color: '#2da888' }} icon={'check-circle-o'}></Icon>
              <span style={{ color: '#2da888', fontSize: '1.2rem', fontWeight: 600 }}>
                {' '}
                Verified
              </span>
              <span> ใช้ข้อมูลจากสำนักบริหารการทะเบียน กรมการปกครอง</span>
            </>
          }
          style={{ marginBottom: 10 }}
        />
      )}

      <Row>
        <Col xs={24} sm={12} md={8} lg={8}>
          <span>&#9679; {fullName}</span>
        </Col>
        <ColData data={data?.idNumber} isIdCard xs={24} sm={12} md={16} lg={16} />
        {/* <ColData data={data?.nationality} value={nationalityValue} /> */}
      </Row>
      <Row>
        {data?.personType && <ColData data={data?.personType} value={personTypeValue} />}
        <ColData data={data?.nationality} value={nationalityValue} />
        <ColData
          data={data?.dateOfBirth}
          value={data?.dateOfBirth?.value && moment(data?.dateOfBirth?.value).format('DD/MM/YYYY')}
        />
      </Row>
      <Row>
        <ColData data={data?.telephone} />
        <ColData data={data?.mobile} />
        <ColData data={data?.fax} />
      </Row>
      <Row>
        <ColData data={data?.email} />
        <ColData data={data?.lineId} />
      </Row>
      {/* <Row>
        {data?.submission?.value === 2 && (
          <Col xs={24} sm={12} md={8} lg={8}>
            <span>&#9679; {data.powerOfAttorney.label}</span>
            {data?.powerOfAttorney?.value ? (
              <div style={{ width: '100%', textAlign: 'center' }}>
                <img
                  src={data.powerOfAttorney.value.path}
                  style={{ width: 'auto', height: '150px' }}
                ></img>
              </div>
            ) : (
              <b>-ไม่ระบุ-</b>
            )}
          </Col>
        )}
        {data.idCard && (
          <Col xs={24} sm={12} md={8} lg={8}>
            <span>&#9679; {data.idCard.label} : </span>
            {data?.idCard?.value ? (
              <ButtonGroup>
                <IconButton
                  appearance="ghost"
                  icon={<Icon appearance="ghost" icon="eye" className="bt-gost-icon-radius" />}
                  onClick={() => {
                    handleFile('view', data.idCard.value.path, data.idCard.value.name)
                  }}
                >
                  แสดง
                </IconButton>
                <IconButton
                  appearance="ghost"
                  icon={
                    <Icon appearance="ghost" icon="download" className="bt-gost-icon-none-radius" />
                  }
                  onClick={() => {
                    handleFile('download', data.idCard.value.path, data.idCard.value.name)
                  }}
                >
                  ดาวน์โหลด
                </IconButton>
              </ButtonGroup>
            ) : (
              // <div style={{ width: '100%', textAlign: 'center' }}>
              //   <img src={data.idCard.value.path} style={{ width: 'auto', height: '150px' }}></img>
              // </div>
              <b>-ไม่ระบุ-</b>
            )}
          </Col>
        )}
        {fileErr && (
          <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
            <Message
              showIcon
              type="error"
              description={fileErr}
              closable
              onClose={() => {
                setFileErr('')
              }}
            />
          </Col>
        )}
      </Row> */}
    </>
  )
}
